import { useState, useEffect } from 'react';
import { getAgencyData } from '../Utils/Storage';

export const useTax = (selectedCountry = null) => {
  const [taxIDLabel, setTaxIDLabel] = useState('Tax ID');

  useEffect(() => {
    let countryToCheck = selectedCountry;
    
    // If no country is passed, get from localStorage
    if (!countryToCheck) {
      countryToCheck = getAgencyData()?.Country || 'India';
    }
    
    // Set tax ID label based on country
    if (countryToCheck === 'India') {
      setTaxIDLabel('GSTIN');
    } else {
      setTaxIDLabel('Tax ID');
    }
  }, [selectedCountry]);

  return taxIDLabel;
};